module.exports = __webpack_public_path__ + "img/Path 18@3x.4c6b41f0.png";